module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEXr6+uInxNMAAAACklEQVQI12NgAAAAAgAB4iG8MwAAAABJRU5ErkJggg=="